var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 448,
    viewBox: "0 0 448 448",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384 112C348.7 112 320 140.7 320 176C320 184.8 327.2 192 336 192C344.8 192 352 184.8 352 176C352 158.4 366.4 144 384 144C401.6 144 416 158.4 416 176C416 193.6 401.6 208 384 208H17.3C8.5 208 1.3 215.2 1.3 224C1.3 232.8 8.5 240 17.3 240H384C419.3 240 448 211.3 448 176C448 140.7 419.3 112 384 112Z",
    fill: "#19A0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 48C188.7 48 160 76.7 160 112C160 120.8 167.2 128 176 128C184.8 128 192 120.8 192 112C192 94.4 206.4 80 224 80C241.6 80 256 94.4 256 112C256 129.6 241.6 144 224 144H16C7.2 144 0 151.2 0 160C0 168.8 7.2 176 16 176H224C259.3 176 288 147.3 288 112C288 76.7 259.3 48 224 48Z",
    fill: "#19A0F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 272H16C7.2 272 0 279.2 0 288C0 296.8 7.2 304 16 304H224C241.6 304 256 318.4 256 336C256 353.6 241.6 368 224 368C206.4 368 192 353.6 192 336C192 327.2 184.8 320 176 320C167.2 320 160 327.2 160 336C160 371.3 188.7 400 224 400C259.3 400 288 371.3 288 336C288 300.7 259.3 272 224 272Z",
    fill: "#19A0F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 448,
    height: 448,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.6f910320e1f74f31ec903e7862b078c7.svg";
export { ForwardRef as ReactComponent };